import * as React from 'react';
import * as styles from './styles.scss';
import { observer } from 'mobx-react-lite';
import { Icon } from '@fluentui/react/lib/Icon';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import { clockName } from '../clockStrings.locstring.json';

export default observer(function ClockViewHeader() {
    return (
        <div className={styles.headerContainer}>
            <Icon className={styles.headerIcon} iconName={ControlIcons.WorldClock} />
            <span>{loc(clockName)}</span>
        </div>
    );
});
